<div class="statusOuter">
    <div class="row margin-left-and-right"  *ngIf="statusData[statusDetails.key].toLowerCase() === 'created'">
        <div class="col-1 statusMainImage marginleft_5p">
                <img src="{{statusDetails.createdImageUrls.created}}"
                class="iconstruck">
            <div>{{statusDetails.createdLabel | translate}}</div>
        </div>
        <div class="col-4 progressMainDiv">
            <div class="progress progressInnerDiv">
                <div class="progress-bar width_70p progressActive" role="progressbar" aria-valuenow="70"
                    aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
        </div>
        <div class="col-1 statusMainImage centerTxtAlign ">
                <img src="{{statusDetails.createdImageUrls.planned}}"
                class="iconstruck">
            <div>{{statusDetails.plannedLabel | translate}}</div>
        </div>
        <div class="col-4 progressMainDiv">
            <div class="progress progressInnerDiv">
                <div class="progress-bar progressActive" role="progressbar" aria-valuenow="0" aria-valuemin="0"
                    aria-valuemax="100">
                </div>
            </div>
        </div>
        <div class="col-1 statusMainImage centerTxtAlign">
                <img  src="{{statusDetails.createdImageUrls.confirmed}}"
                class="iconstruck">
            <div class="fltrght">{{statusDetails.confirmedLabel | translate}}</div>
        </div>
    </div>
    <div class="row margin-left-and-right" *ngIf="statusData[statusDetails.key].toLowerCase() === 'planned'">
        <div class="col-1 statusMainImage marginleft_5p">
                <img  src="{{statusDetails.plannedImageUrls.created}}"
                class="iconstruck">
            <div>{{statusDetails.createdLabel | translate}}</div>
        </div>
        <div class="col-4 progressMainDiv">
            <div class="progress progressInnerDiv">
                <div class="progress-bar width_100p progressActive" role="progressbar" aria-valuenow="100"
                    aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
        </div>
        <div class="col-1 statusMainImage centerTxtAlign ">
                <img src="{{statusDetails.plannedImageUrls.planned}}"
                class="iconstruck">
            <div>{{statusDetails.plannedLabel | translate}}</div>
        </div>
        <div class="col-4 progressMainDiv">
            <div class="progress progressInnerDiv">
                <div class="progress-bar width_50p progressActive" role="progressbar" aria-valuenow="50"
                    aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
        </div>
        <div class="col-1 statusMainImage centerTxtAlign">
                <img  src="{{statusDetails.plannedImageUrls.confirmed}}"
                class="iconstruck">
            <div class="fltrght">{{statusDetails.confirmedLabel | translate}}</div>
        </div>
    </div>
    <div class="row margin-left-and-right" *ngIf="statusData[statusDetails.key].toLowerCase() === 'confirmed'">
        <div class="col-1 statusMainImage marginleft_5p">
                <img  src="{{statusDetails.confirmedImageUrls.created}}"
                class="iconstruck">
            <div>{{statusDetails.createdLabel | translate}}</div>
        </div>
        <div class="col-4 progressMainDiv">
            <div class="progress progressInnerDiv">
                <div class="progress-bar width_100p progressActive" role="progressbar" aria-valuenow="100"
                    aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
        </div>
        <div class="col-1 statusMainImage centerTxtAlign ">
                <img src="{{statusDetails.confirmedImageUrls.planned}}"
                class="iconstruck">
            <div>{{statusDetails.plannedLabel | translate }}</div>
        </div>
        <div class="col-4 progressMainDiv">
            <div class="progress progressInnerDiv">
                <div class="progress-bar width_100p progressActive" role="progressbar" aria-valuenow="100"
                    aria-valuemin="0" aria-valuemax="100">
                </div>
            </div>
        </div>
        <div class="col-1 statusMainImage centerTxtAlign">
                <img  src="{{statusDetails.confirmedImageUrls.confirmed}}"
                class="iconstruck">
            <div class="fltrght">{{statusDetails.confirmedLabel | translate }}</div>
        </div>
    </div>
</div>